
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

export default function Disclaimer() {
  return (
    <main className="flex min-h-screen flex-col">
      <SEO 
        title="Disclaimer | Legal Information for Secondary Glazing Services"
        description="Important legal disclaimer and liability information for London Secondary Glazing services. Understand the terms, limitations, and professional advice regarding our glazing solutions."
        canonical="https://www.londonsecondaryglazing.co.uk/disclaimer"
        keywords="disclaimer, legal notice, terms of use, liability, secondary glazing disclaimer, professional advice"
      />
      <Navbar />
      <div className="container mx-auto px-4 py-16 flex-grow">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-primary">Disclaimer</h1>
          <div className="prose max-w-none">
            <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Website Information</h2>
              <p>The information provided on SecondaryGlazing.London is for general information purposes only. While we strive to keep the information up to date and accurate, we make no representations or warranties of any kind about the completeness, accuracy, reliability, suitability, or availability of the website or the information contained on it.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. Professional Advice</h2>
              <p>Any reliance you place on information found on our website is strictly at your own risk. You should always seek professional advice for your specific circumstances before taking any action based on website content.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Third-Party Links</h2>
              <p>Our website may contain links to third-party websites. We have no control over the content and nature of these sites and are not responsible for their content or privacy practices.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
